module.exports = __webpack_public_path__ + "img/feedback_icon.3f554211.svg";